'use client';

import { useState } from 'react';
import { useTranslation } from '@root/src/i18n/client';

export default function NewsletterBanner() {
  const [email, setEmail] = useState('');
  const { t } = useTranslation('common');

  return (
    <div className="mt-8 rounded-2xl overflow-hidden bg-[#F5EEE0] relative">
      {/* Subtle background decoration */}
      <div className="absolute right-0 top-0 bottom-0 w-48 opacity-10 pointer-events-none">
        <svg viewBox="0 0 200 200" className="w-full h-full" fill="none">
          <circle cx="180" cy="100" r="120" fill="#223A27"/>
        </svg>
      </div>

      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 px-8 py-8 md:py-10">
        {/* Text */}
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#223A27]/60 font-medium mb-1">
            {t('lytra.newsletterLabel')}
          </p>
          <p className="text-sm text-[#4A4A42]">
            {t('lytra.newsletterDesc')}
          </p>
        </div>

        {/* Email form */}
        <div className="flex items-center gap-2 w-full md:w-auto">
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder={t('lytra.newsletterPlaceholder')}
            className="flex-1 md:w-64 px-4 py-2.5 rounded-full border border-[#D8D0C0] bg-white text-sm text-[#2C2C2C] placeholder:text-[#A0998A] outline-none focus:border-[#223A27] transition-colors"
          />
          <button className="px-5 py-2.5 bg-[#223A27] text-white text-sm font-semibold rounded-full hover:bg-[#1a2b1e] transition-colors whitespace-nowrap">
            {t('lytra.newsletterButton')}
          </button>
        </div>
      </div>
    </div>
  );
}
